import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-agents-page',
  templateUrl: './agents-page.component.html',
  styleUrls: ['./agents-page.component.scss']
})
export class AgentsPageComponent implements OnInit {
  activeTab: 'agents' | 'commissions' = 'agents';

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.activeTab = this.router.url.includes('commissions') ? 'commissions' : 'agents';
  }

}
